var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIlsNoSearch = function SvgIlsNoSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6074 0.0114726C65.4566 0.233473 79.6354 3.95482 89.1313 14.7398C98.4066 25.2743 100.481 40.4176 99.9135 54.8755C99.373 68.636 95.8419 82.7618 86.1057 91.7749C76.8659 100.329 63.7911 100.598 51.6074 99.5941C40.5518 98.6831 30.6324 93.9983 22.0443 86.4962C12.2132 77.9082 2.09401 68.333 0.415426 54.8755C-1.4471 39.9434 2.99257 24.1812 12.9416 13.5185C22.8984 2.84755 37.5139 -0.214443 51.6074 0.0114726Z",
    fill: "#F96274"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6666 68.0002C53.3999 67.9992 57.9967 66.4146 61.7253 63.4988L73.4479 75.2215L77.2186 71.4508L65.4959 59.7282C68.4133 55.9993 69.9988 51.4013 69.9999 46.6668C69.9999 34.9042 60.4293 25.3335 48.6666 25.3335C36.9039 25.3335 27.3333 34.9042 27.3333 46.6668C27.3333 58.4295 36.9039 68.0002 48.6666 68.0002ZM48.6666 30.6668C57.4906 30.6668 64.6666 37.8428 64.6666 46.6668C64.6666 55.4908 57.4906 62.6668 48.6666 62.6668C39.8426 62.6668 32.6666 55.4908 32.6666 46.6668C32.6666 37.8428 39.8426 30.6668 48.6666 30.6668Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4319 42.8962C53.4426 43.9096 53.9999 45.2482 53.9999 46.6669H59.3333C59.3356 45.2654 59.0602 43.8773 58.5228 42.5829C57.9855 41.2884 57.1969 40.1134 56.2026 39.1256C52.1653 35.0936 45.1653 35.0936 41.1306 39.1256L44.896 42.9016C46.9226 40.8802 50.4159 40.8856 52.4319 42.8962Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIlsNoSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ils-no-search.e34f4513.svg";
export { ForwardRef as ReactComponent };